import React from 'react';
import { CollapseIcon } from './icons';
import { ArcIconButton, ArcStack, ArcTooltip } from '@src/core/ui';
import { cameraPillSx } from './camera-pill-sx';
import { CAMERA_TOOLBAR_ICON_BUTTON_SX } from './toolbar-icon-button-sx';

interface PipMapCollapseButtonProps {
  onClick: () => void;
}

/** Collapse control for the map PiP in Swap (`pip`) mode — lives on the map, not on fullscreen video. */
const PipMapCollapseButton: React.FC<PipMapCollapseButtonProps> = ({ onClick }) => (
  <ArcStack
    top={8}
    right={8}
    zIndex={101}
    position='absolute'
    direction='row'
    alignItems='center'
    sx={(theme) => cameraPillSx(theme)}>
    <ArcTooltip title='Collapse'>
      <ArcIconButton onClick={onClick} sx={CAMERA_TOOLBAR_ICON_BUTTON_SX}>
        <CollapseIcon />
      </ArcIconButton>
    </ArcTooltip>
  </ArcStack>
);

export default PipMapCollapseButton;
